module.exports = __webpack_public_path__ + "img/shop03.6ee78046.jpg";